<app-range-linechart-voor-lesgroeptabel
  [gebruikPerWeek]="data.gebruikPerWeek" [model]="data.data" *ngIf="!data.hidden">
</app-range-linechart-voor-lesgroeptabel>
